import PropTypes from 'prop-types';
import { renderRichText } from 'gatsby-source-contentful/rich-text';

const LegalContent = ({ title, body, updatedAt }) => {
	return (
		<div className="legal-content typography typography--body">
			<p  className="legal-content--center typography typography--overline">
				Terms & Policies
			</p>
			<h1 className="legal-content--center typography typography--h1 typography--secondary">{title}</h1>
			<p className="legal-content--center typography typography--h6">
				<strong>
					Last updated:{' '}
					{new Date(updatedAt).toLocaleDateString('en-US', {
						year: 'numeric',
						month: 'long',
						day: '2-digit',
					})}
				</strong>
			</p>
			{renderRichText(body)}
		</div>
	);
};

LegalContent.propTypes = {
	title: PropTypes.node.isRequired,
	body: PropTypes.shape({
		raw: PropTypes.string,
	}),
	updatedAt: PropTypes.string.isRequired,
};

export default LegalContent;
